import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  // base: '/evoKey',  //项目路径
  // mode: 'history',  //去掉url中的#
  routes: [
    {
      path: "/",
      redirect: "/login",
    },
    {
      path: "*",
      redirect: "/login",
    },
    {
      path: "/load",
      component: (resolve) => require(["@/views/other/Login.vue"], resolve),
      children: [
        {
          path: "/",
          component: (resolve) => require(["@/views/other/Login.vue"], resolve),
        },
        {
          path: "/login",
          component: (resolve) => require(["@/views/other/Login.vue"], resolve),
        },
      ],
    },
    {
      path: "/home",
      component: (resolve) => require(["../views/layout/Home.vue"], resolve),
      children: [
        {
          path: "/gis",
          component: (resolve) =>
            require(["../views/workbench/gis/Table.vue"], resolve),
        },
        {
          path: "/device",
          component: (resolve) =>
            require(["../views/device/Table.vue"], resolve),
        },
        {
          path: "/bleTable",
          component: (resolve) =>
            require(["../views/device/bleTable.vue"], resolve),
        },
        {
          path: "/regularUser",
          component: (resolve) => require(["../views/user/Table.vue"], resolve),
        },
        {
          path: "/temporaryUser",
          component: (resolve) => require(["../views/user/Table.vue"], resolve),
        },
        {
          path: "/teamManagement",
          component: (resolve) =>
            require(["../views/user/components/TeamManagement.vue"], resolve),
        },
        {
          path: "/ordinaryUser",
          component: (resolve) => require(["../views/user/Table.vue"], resolve),
        },
        {
          path: "/guestUser",
          component: (resolve) => require(["../views/user/Table.vue"], resolve),
        },
        {
          path: "/userPower",
          component: (resolve) => require(["../views/user/Table.vue"], resolve),
        },
        {
          path: "/guestPower",
          component: (resolve) => require(["../views/user/Table.vue"], resolve),
        },
        {
          path: "/devicePower",
          component: (resolve) =>
            require(["../views/device/devicePower.vue"], resolve),
        },
        {
          path: "/logDevice",
          component: (resolve) => require(["../views/log/Table.vue"], resolve),
        },
        {
          path: "/site",
          component: (resolve) => require(["../views/site/Table.vue"], resolve),
        },
        {
          path: "/siteCreate",
          component: (resolve) =>
            require(["../views/site/Create.vue"], resolve),
        },
        {
          path: "/siteEdit",
          component: (resolve) => require(["../views/site/Edit.vue"], resolve),
        },
        {
          path: "/personalInfo",
          component: (resolve) =>
            require(["../views/other/PersonalInfo.vue"], resolve),
        },
        {
          path: "/distributionAuthority",
          component: (resolve) =>
            require(["../views/distribution/Table.vue"], resolve),
        },
        {
          path: "/systemArea",
          component: (resolve) =>
            require(["../views/system/area/Table.vue"], resolve),
        },
        {
          path: "/systemDepartment",
          component: (resolve) =>
            require(["../views/system/department/Table.vue"], resolve),
        },
        {
          path: "/systemRole",
          component: (resolve) =>
            require(["../views/system/role/Table.vue"], resolve),
        },
        {
          path: "/systemOperator",
          component: (resolve) =>
            require(["../views/user/components/systemOperator.vue"], resolve),
        },
        {
          path: "/systemRoleCreate",
          component: (resolve) =>
            require(["../views/system/role/Info.vue"], resolve),
        },
        {
          path: "/systemRoleEdit",
          component: (resolve) =>
            require(["../views/system/role/Info.vue"], resolve),
        },
        {
          path: "/systemGroup",
          component: (resolve) =>
            require(["../views/system/group/Table.vue"], resolve),
        },
        {
          path: "/systemGroupCreate",
          component: (resolve) =>
            require(["../views/system/group/Create.vue"], resolve),
        },
        {
          path: "/systemGroupEdit",
          component: (resolve) =>
            require(["../views/system/group/Edit.vue"], resolve),
        },
        {
          path: "/systemTimeTemplate",
          component: (resolve) =>
            require(["../views/system/timeTemplate/Table.vue"], resolve),
        },
      ],
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js